/* ab-main-product.js — gallery, tabs, variant/plan logic, add to cart + cart drawer (vanilla) */
(function () {
  var $ = function (r, s) { return r.querySelector(s); };
  var $$ = function (r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  function init(root) {
    if (root.__ab) return; root.__ab = true;
    var dataEl = $(root, '[data-ab-data]'); if (!dataEl) return;
    var D = JSON.parse(dataEl.textContent);
    var form = $(root, '[data-ab-form]');
    var idIn = $(form, '[data-ab-id]'), planIn = $(form, '[data-ab-plan]');
    var atc = $(form, '[data-ab-atc]'), atcLabel = $(form, '[data-ab-atc-label]'), err = $(form, '[data-ab-err]');
    var track = $(root, '[data-ab-track]'), slides = $$(root, '[data-ab-slide]'), thumbs = $$(root, '[data-ab-thumb]');
    var prev = $(root, '[data-ab-prev]'), next = $(root, '[data-ab-next]');
    var state = { variantId: +idIn.value, mode: planIn.disabled ? 'otp' : 'sub', pref: 'sub' };

    function variant() { return D.variants.filter(function (v) { return v.id === state.variantId; })[0] || D.variants[0]; }
    function plan(v) {
      if (!v.plans.length) return null;
      var m = (v.label.match(/\d+/) || ['1'])[0], hit = null;
      v.plans.forEach(function (p) {
        if (hit) return;
        var n = p.name.toLowerCase();
        if (m === '1' ? (n.indexOf('chaque mois') > -1 || n.indexOf('1 mois') > -1) : n.indexOf(m + ' mois') > -1) hit = p;
      });
      return hit || (m === '1' ? v.plans[0] : null);
    }

    /* gallery */
    function idx() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    function show(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
      mark(i);
    }
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (prev) prev.disabled = i === 0; if (next) next.disabled = i >= slides.length - 1;
      var t = thumbs[i]; if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - 40, behavior: 'smooth' });
    }
    if (track) {
      var raf; track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { mark(idx()); }); }, { passive: true });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      if (prev) prev.addEventListener('click', function () { show(idx() - 1); });
      if (next) next.addEventListener('click', function () { show(idx() + 1); });
      mark(0);
    }

    /* tabs */
    var tabs = $$(root, '[data-ab-tab]'), panels = $$(root, '[data-ab-panel]');
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-ab-tab');
        tabs.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
        panels.forEach(function (p) { var on = p.getAttribute('data-ab-panel') === k; p.classList.toggle('is-active', on); p.hidden = !on; });
      });
    });

    /* render price state */
    var optSub = $(root, '[data-ab-opt="sub"]'), optOtp = $(root, '[data-ab-opt="otp"]');
    function render() {
      var v = variant(), p = plan(v);
      idIn.value = v.id;
      if (optSub) {
        optSub.hidden = !p;
        if (p) {
          $(root, '[data-ab-struck]').textContent = v.priceF;
          $(root, '[data-ab-subprice]').textContent = p.priceF;
          var pct = v.price > 0 ? Math.round((v.price - p.price) * 100 / v.price) : 0;
          var fl = $(root, '[data-ab-flag]');
          if (fl) {
            if (D.badgeOverride) fl.textContent = D.badgeOverride;
            else { fl.textContent = D.badgePrefix + ' −' + pct + ' %'; fl.hidden = pct <= 0; }
          }
        }
      }
      state.mode = (p && state.pref === 'sub') ? 'sub' : 'otp';
      $(root, '[data-ab-otpprice]').textContent = v.priceF;
      var sub = state.mode === 'sub' && !!p;
      [optSub, optOtp].forEach(function (o) { if (!o) return; var on = (o === optSub) === sub; o.classList.toggle('is-on', on); o.setAttribute('aria-checked', on); o.tabIndex = on ? 0 : -1; });
      planIn.value = p ? p.id : ''; planIn.disabled = !sub;
      $$(root, '[data-ab-var]').forEach(function (c) { var on = +c.getAttribute('data-ab-var') === v.id; c.classList.toggle('is-on', on); c.setAttribute('aria-checked', on); });
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? D.cta : D.soldOut;
      if (v.media) { var k = slides.map(function (s) { return +s.getAttribute('data-media-id'); }).indexOf(v.media); if (k > -1) show(k); }
      var det = { label: v.label, price: sub ? p.priceF : v.priceF, image: v.image, available: v.available };
      window.ABBuybox = window.ABBuybox || {}; window.ABBuybox.last = det;
      document.dispatchEvent(new CustomEvent('ab:buybox', { detail: det }));
    }
    $$(root, '[data-ab-var]').forEach(function (c) { c.addEventListener('click', function () { state.variantId = +c.getAttribute('data-ab-var'); render(); }); });
    [optSub, optOtp].forEach(function (o) {
      if (!o) return;
      o.addEventListener('click', function () { state.pref = o.getAttribute('data-ab-opt'); render(); });
      o.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); o.click(); }
        else if (/Arrow/.test(e.key)) { e.preventDefault(); var t = o === optSub ? optOtp : optSub; if (t && !t.hidden) { t.click(); t.focus(); } }
      });
    });
    render();

    /* add to cart */
    async function add() {
      if (atc.getAttribute('aria-busy') === 'true' || atc.disabled) return;
      atc.setAttribute('aria-busy', 'true'); err.hidden = true;
      var c = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      var fd = new FormData(form);
      if (c && typeof c.getSectionsToRender === 'function') {
        fd.append('sections', c.getSectionsToRender().map(function (x) { return x.id; }));
        fd.append('sections_url', window.location.pathname);
        if (typeof c.setActiveElement === 'function') c.setActiveElement(document.activeElement);
      }
      try {
        var res = await fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
        var j = await res.json();
        if (!res.ok || j.status) { err.textContent = j.description || j.message || 'Erreur'; err.hidden = false; document.dispatchEvent(new CustomEvent('ab:added', { detail: { ok: false } })); return; }
        document.dispatchEvent(new CustomEvent('ab:added', { detail: { ok: true } }));
        if (c && typeof c.renderContents === 'function' && j.sections) {
          c.classList.remove('is-empty');
          var inner = c.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          c.renderContents(j);
        } else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      } catch (e) { form.submit(); } finally { atc.removeAttribute('aria-busy'); }
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    root.__abAdd = add;
    window.ABBuybox.add = add; window.ABBuybox.atc = atc; window.ABBuybox.root = root;
  }

  function boot() { $$(document, '[data-ab-main]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
